<template>
  <div class="d-flex text-left" v-if="!isLoading">
    <form @submit.prevent class="w-100">
      <b-input-group class="panel-input-serach">
        <b-form-input
          :id="'inventorySearch' + name"
          class="input-serach"
          placeholder="ค้นหาชื่อสินค้า, คอลเลคชั่นสินค้า"
          v-model="filterSelected.search"
          v-on:keyup.13="enterFilter"
        ></b-form-input>
        <b-input-group-prepend
          :id="'btnInventorySearch' + name"
          @click="onSubmitFilter"
        >
          <span class="icon-input m-auto pr-2">
            <font-awesome-icon icon="search" title="View" />
          </span>
        </b-input-group-prepend>
      </b-input-group>
    </form>
    <b-dropdown
      :id="'dropdownInventory' + name"
      text="ตัวเลือกเพิ่มเติม"
      class="ml-2 dropdown-option"
    >
      <b-dropdown-item
        @click="$router.push('/product/details/0')"
        :id="'dropdownInventory' + name + 'Import'"
        >นำเข้าข้อมูล</b-dropdown-item
      >
      <b-dropdown-item>นำออกข้อมูล</b-dropdown-item>
      <b-dropdown-item>ดาวน์โหลดไฟล์ต้นฉบับ</b-dropdown-item>
    </b-dropdown>

    <b-button
      :id="'btnInventory' + name + 'Filter'"
      v-b-toggle="'sideBarInventory' + name + 'Filter'"
      class="btn-filter ml-2"
    >
      <font-awesome-icon
        icon="filter"
        title="filter-btn"
        class="main-color mr-0 mr-sm-1"
      />
      <span class="d-none d-sm-inline">ตัวกรอง </span>
    </b-button>

    <b-sidebar
      :id="'sideBarInventory' + name + 'Filter'"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      ref="filterSidebar"
      aria-labelledby="sidebar-filter-title"
      no-header
    >
      <template #default="{ hide }">
        <div class="p-3 sidebar-filter-header d-flex justify-content-between">
          <h4 id="sidebar-filter-title" class="m-0">ตัวกรอง</h4>
          <font-awesome-icon
            :id="'btnInventory' + name + 'HideFilter'"
            class="my-auto"
            icon="times-circle"
            color="#FFFFFF"
            @click="hide"
          />
        </div>
        <div class="px-3 py-2">
          <div class="mt-2">
            <b-input-group class="panel-input-serach">
              <b-form-input
                :id="'inventorySearch' + name"
                class="input-serach"
                placeholder="ค้นหาชื่อสินค้า, SKU, คอลเลคชั่นสินค้า"
                v-model="filterSelected.search"
                v-on:keyup.13="enterFilter"
              ></b-form-input>
              <b-input-group-prepend @click="onSubmitFilter">
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon icon="search" title="View" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">ประเภทสินค้าในระบบ</div>
            <b-form-group>
              <b-form-checkbox
                v-for="(type, index) in productInventoryTypes"
                :id="'inventory' + name + 'FilterType' + type.productTypeId"
                :key="index"
                :value="type.productTypeId"
                class="mb-2"
                v-model="filterSelected.productInventoryTypes"
                >{{ type.productType }}</b-form-checkbox
              >
            </b-form-group>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">สถานะสินค้า</div>
            <b-form-group>
              <b-form-checkbox
                :id="'inventory' + name + 'FilterStatus2'"
                class="mb-2"
                v-model="isProductStatusAll"
                @change="handleIsProductStatusAll"
                >ทั้งหมด</b-form-checkbox
              >
              <b-form-checkbox
                v-for="(status, index) in productStatus"
                :id="'inventory' + name + 'FilterStatus' + status.productStatusId"
                :key="index"
                :value="status.productStatusId"
                class="mb-2"
                v-model="filterSelected.productStatus"
                >{{ status.productStatusName }}</b-form-checkbox
              >
            </b-form-group>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">
              หมวดหมู่ระดับที่ 1
            </div>
            <b-form-select
              class="btn-select py-1"
              :id="'inventory' + name + 'FilterCategory1'"
              v-model="filterSelected.categories[0]"
              @change="changeCategoryList($event, 1)"
              :options="categoryList.category1"
            ></b-form-select>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">
              หมวดหมู่ระดับที่ 2
            </div>
            <b-form-select
              class="btn-select py-1"
              :id="'inventory' + name + 'FilterCategory2'"
              v-model="filterSelected.categories[1]"
              @change="changeCategoryList($event, 2)"
              :options="categoryList.category2"
            ></b-form-select>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">
              หมวดหมู่ระดับที่ 3
            </div>
            <b-form-select
              class="btn-select py-1"
              v-model="filterSelected.categories[2]"
              :id="'inventory' + name + 'FilterCategory3'"
              @change="changeCategoryList($event, 3)"
              :options="categoryList.category3"
            ></b-form-select>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">
              หมวดหมู่ระดับที่ 4
            </div>
            <b-form-select
              class="btn-select py-1"
              v-model="filterSelected.categories[3]"
              :id="'inventory' + name + 'FilterCategory4'"
              @change="changeCategoryList($event, 4)"
              :options="categoryList.category4"
            ></b-form-select>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">คอลเลคชัน</div>
            <b-form-select
              class="btn-select py-1"
              :id="'inventory' + name + 'FilterCollection'"
              v-model="filterSelected.collections"
              :options="collections"
              value-field="value"
            ></b-form-select>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">จำนวนสินค้าในคลัง</div>
            <b-form-select
              :id="'inventory' + name + 'FilterStockStatus'"
              class="btn-select py-1"
              v-model="filterSelected.stockStatus[0]"
              :options="stockStatus"
            ></b-form-select>
          </div>
          <div class="mt-3">
            <div class="font-weight-bold mb-2">สินค้าใหม่</div>
            <div>
              <label class="mb-1">เริ่มต้น</label>
              <div class="input-container">
                <datetime
                  :input-style="styleDatetime"
                  v-model="filterSelected.StartDate"
                  placeholder="วว / ดด / ปป"
                  ref="transferStartDate"
                  :input-id="'inventory' + name + 'FilterStartDate'"
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.transferStartDate.isOpen = true"
                >
                  <font-awesome-icon
                    icon="calendar-alt"
                    class="pointer"
                    color="#B41BB4"
                  />
                </div>
              </div>
              <label class="mb-1 mt-2">สิ้นสุด</label>
              <div class="input-container">
                <datetime
                  :input-style="styleDatetime"
                  v-model="filterSelected.EndDate"
                  placeholder="วว / ดด / ปป"
                  ref="transferEndDate"
                  :input-id="'inventory' + name + 'FilterEndDate'"
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.transferEndDate.isOpen = true"
                >
                  <font-awesome-icon
                    icon="calendar-alt"
                    class="pointer"
                    color="#B41BB4"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div
          class="
            d-flex
            justify-content-between
            shadow
            align-items-center
            border-top
          "
        >
          <div class="w-100">
            <b-button
              block
              size="lg"
              variant="light"
              class="text-dark w-100 border-radius-0 btn-clear-filter"
              @click="clearFilter"
              :id="'inventory' + name + 'ClearFilter'"
              >ล้างตัวกรอง</b-button
            >
          </div>
          <div class="w-100">
            <b-button
              v-b-toggle="'sidebar-filter-' + name"
              @click="onSubmitFilter"
              block
              size="lg"
              variant="light"
              class="text-body btn-main w-100 border-radius-0"
              :id="'inventory' + name + 'SubmitFilter'"
            >
              ยืนยัน
            </b-button>
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
export default {
  components: {
    InputSelect,
  },
  props: {
    name: {
      required: false,
      type: String,
    },
  },
  watch: {
    'filterSelected.productStatus'(newValue, oldValue) {
      if(newValue.length == 2) {
        this.isProductStatusAll = true;
      }else {
        this.isProductStatusAll = false;
      }
    },
  },
  data() {
    return {
      isLoading: true,
      isProductStatusAll: false,
      filter: {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        collections: "",
        stockStatus: [3],
        StartDate: "",
        EndDate: "",
        perPage: 10,
        page: 1,
      },
      filterSelected: {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        collections: "",
        stockStatus: [3],
        StartDate: "",
        EndDate: "",
        perPage: 10,
        page: 1,
      },
      collectionList: [
        {
          id: 0,
          name: "ทั้งหมด",
        },
        {
          id: 1,
          name: "Winter 2021",
        },
      ],
      stockStatusList: [
        {
          id: 0,
          name: "ทั้งหมด",
        },
        {
          id: 1,
          name: "ปกติ",
        },
        {
          id: 2,
          name: "เหลือน้อย",
        },
        {
          id: 3,
          name: "สินค้าหมด",
        },
      ],
      collections: [
        {
          value: "",
          text: "ทั้งหมด",
        },
      ],
      productInventoryTypes: [],
      productStatus: [],
      stockStatus: [],
      categoryList: {
        category1: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category2: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category3: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category4: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
      },
      styleDatetime: {
        width: "100%",
        border: "none",
      },
    };
  },
  created() {
    this.isLoading = true;
    this.getFilterList();
    this.getCategoryList(0);
    this.isLoading = false;
  },
  methods: {
    handleIsProductStatusAll(val){
      if(val) this.filterSelected.productStatus = [0,1];
      else this.filterSelected.productStatus = [];
    },
    setFilter: async function (filter) {
      if(!filter.categories.toString()) filter.categories = [0,0,0,0]
      if(!filter.stockStatus.toString()) filter.stockStatus = [3]
      await filter.categories.forEach(async (ele, i) => {
        if(ele > 0) {
          await this.changeCategoryList(ele, i+1);
        }
      });
      this.filterSelected = filter;
      this.filter = filter;
    },
    onSubmitFilter() {
      this.filter.search = this.filterSelected.search;
      this.filter.productInventoryTypes = this.filterSelected.productInventoryTypes;
      this.filter.productStatus = this.filterSelected.productStatus;
      this.filter.categories = this.filterSelected.categories;
      this.filter.collections = this.filterSelected.collections;
      this.filter.stockStatus = this.filterSelected.stockStatus;
      this.filter.StartDate = this.filterSelected.StartDate;
      this.filter.EndDate = this.filterSelected.EndDate;
      this.filter.perPage = this.filterSelected.perPage;
      this.filter.page = 1;

      // if (
      //   JSON.stringify(this.filterSelected.categories) !== JSON.stringify([0, 0, 0, 0])
      // ) {
      //   this.filter.categories = [this.filterSelected.categories[3]];
      // }
      this.$emit("onSubmitFilter", this.filter);
      this.$refs.filterSidebar.hide();
    },
    enterFilter(event) {
      console.log(`event`, event);
      if (event.which === 13) {
        this.onSubmitFilter();
      }
    },
    getFilterList() {
      this.axios
        .get(`${this.$baseUrl}/productinventory/config`)
        .then((data) => {
          data.detail.collections.forEach((c) => {
            this.collections.push({ value: c.collection, text: c.collection });
          });
          this.productInventoryTypes = data.detail.productInventoryTypes;
          this.productStatus = data.detail.productStatus.filter((ele) => {
            return ele.productStatusId != 2;
          });
          data.detail.stockStatus.forEach((s) => {
            this.stockStatus.push({
              value: s.stockStatusId,
              text: s.stockStatusName,
            });
          });
        });
    },
    getCategoryList(id) {
      this.axios
        .get(`${this.$baseUrl}/productinventory/category/${id}`)
        .then((data) => {
          data.detail.category.forEach((l) => {
            this.categoryList.category1.push({
              value: l.categoryId,
              text: l.categoryName,
            });
          });
        });
    },
    changeCategoryList(id, index) {
      this.clearCategory(index);
      this.axios
        .get(`${this.$baseUrl}/productinventory/category/${id}`)
        .then((data) => {
          if (data.detail) {
            data.detail.category.forEach((l) => {
              this.categoryList[`category${index + 1}`].push({
                value: l.categoryId,
                text: l.categoryName,
              });
            });
          }
        });
    },
    clearCategory(index) {
      for (let i = 1; i <= 4; i++) {
        if (i > index) {
          this.categoryList[`category${i}`] = [
            {
              value: 0,
              text: "ทั้งหมด",
            },
          ];
          this.filter.categories[i - 1] = 0;
        }
      }
    },
    clearFilter() {
      this.filter = {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        collections: "",
        stockStatus: [3],
        perPage: 10,
        page: 1,
        StartDate: "",
        EndDate: "",
      };
      this.filterSelected = {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        collections: "",
        stockStatus: [3],
        StartDate: "",
        EndDate: "",
        perPage: 10,
        page: 1,
      };
      this.productInventoryTypes = [];
      this.productStatus = [];
      this.stockStatus = [];
      this.collections = [
        {
          value: "",
          text: "ทั้งหมด",
        },
      ];
      this.categoryList = {
        category1: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category2: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category3: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category4: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
      };
      this.getFilterList();
      this.getCategoryList(0);
      this.$emit("onSubmitFilter", this.filter);
      this.$refs.filterSidebar.hide();
    },
  },
};
</script>

<style scoped>
::v-deep .btn-select {
  color: #404040;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  padding: 9px 10px;
  cursor: pointer;
}
::v-deep .btn-select.custom-select-lg {
  height: 55px;
  font-size: 1rem;
}
::v-deep .btn-select:focus {
  border-color: #80c141;
}
::v-deep .btn-select > option {
  background-color: white;
  color: #16274a;
}
::v-deep .btn-select > option:checked {
  color: #16274a !important;
}
::v-deep .btn-select:focus {
  box-shadow: unset !important;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
}
</style>
